import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/Button";
import Textfield from "../../components/Textfield";
import { Validation, User } from "./Validation";
import { Colors, Text } from "../../config/Constants";
import { useUserContext } from "../../contexts/UserContext";
import { useLoadContext } from "../../contexts/LoadContext";
import { adminLogin } from "../../services/adminService";
import { toast } from "react-toastify";
import { ToastMessage } from "../../components/ToastMessage";
import { encryptItem } from "../../utils";
const loginBg = require("../../assets/images/Loginbg.png");

const Login = () => {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({
    email: "",
    password: "",
  });
  const { setUser } = useUserContext();
  const { setLoader } = useLoadContext();

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    let user: User = { email: email, password: password };
    const isValid = Validation(user, setError);
    if (isValid) {
      postLoginData(user);
    }
  };

  const postLoginData = async (user: User) => {
    setLoader(true);
    try {
      const response = await adminLogin(user);
      if (response.status === 200) {
        setUser(response?.data?.role);
        // localStorage.setItem("user", response?.data?.role);
        localStorage.setItem("token", response.data.token);
        encryptItem({"user": response?.data?.role})
        navigate(
          `/admin${response?.data?.role === 1
            ? "/dashboard"
            : response?.data?.role === 2
              ? "/physical-card"
              : response?.data?.role === 3
                ? "/dispute"
                : response?.data?.role === 5
                  ? "/aqua"
                  : response?.data?.role === 6
                    ? "/lww-ticket"
                    : "/push-notification"
          }`
        );
      }
    } catch (error: any) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoader(false);
  };

  return (
    <LoginStyled>
      <LoginModal>
        <InnerDiv>
          <Logo src={require("../../assets/images/logo.png")} alt="logo" />
          <HeaderRight>{Text.loginHeader}</HeaderRight>
          <SubHeaderRight>{Text.loginSubHeader}</SubHeaderRight>
          <LoginForm>
            <div>
              <Textfield
                placeholder={Text.loginEmailPlaceholder}
                variant="Email id"
                value={email}
                size="large"
                isRounded={true}
                error={error.email ? true : false}
                onChange={(e) => {
                  setError((prevState: any) => {
                    return { ...prevState, email: "" };
                  });
                  setEmail(e.target.value);
                }}
                type="text"
                color={Colors.secondaryBlack}
                placeholderColor={Colors.santasGray}
              />
              {error.email && <ErrorMessage>{error.email}</ErrorMessage>}
            </div>
            <div>
              <Textfield
                placeholder={Text.loginPasswordPlaceholder}
                variant="Password"
                value={password}
                size="large"
                isRounded={true}
                error={error.password ? true : false}
                onChange={(e) => {
                  setError((prevState: any) => {
                    return { ...prevState, password: "" };
                  });
                  setPassword(e.target.value);
                }}
                type="password"
                textColor={Colors.secondaryBlack}
                placeholderColor={Colors.santasGray}
              />
              {error.password && <ErrorMessage>{error.password}</ErrorMessage>}
            </div>
            <Button
              label="Login"
              variant="filled"
              color={Colors.solidRed}
              size="large"
              onClick={(e) => handleSubmit(e)}
            />
          </LoginForm>
        </InnerDiv>
      </LoginModal>
    </LoginStyled>
  );
};

export default Login;

const LoginStyled = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${loginBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
const LoginModal = styled.div`
  width: 31.7rem;
  height: 36.3rem;
  border-radius: 0.5rem;
  background: ${Colors.blackOpacity};
  @media only screen and (max-width: 768px) {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    display: flex;
    justify-content: center;
  }
`;
const InnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Logo = styled.img`
  width: 19.5rem;
  height: 14rem;
  @media only screen and (max-width: 768px) {
    margin: 2rem 0;
  }
`;
const HeaderRight = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1.5rem;
  color: ${Colors.blackSqueeze};
  margin-top: -1.7rem;
`;
const SubHeaderRight = styled.div`
  font-family: "Poppins-Book";
  font-size: 0.875rem;
  color: ${Colors.mischkaApprox};
  margin-top: 1.2rem;
  margin-bottom: 3rem;
`;
const LoginForm = styled.form`
  width: 20rem;
  height: 12rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const ErrorMessage = styled.div`
  font-family: "Poppins-Book";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  position: absolute;
  margin-top: 0.25rem;
`;
